import { CustomerErrorDetailsDtoCodeEnum } from '@/api/generated';

/** The approval flow codes a customer creation answers with: a status other than Prospekt or a missing permission. */
export const CUSTOMER_CREATE_ERROR_CODES: readonly CustomerErrorDetailsDtoCodeEnum[] = [
  CustomerErrorDetailsDtoCodeEnum.CustomerApproveRequired,
  CustomerErrorDetailsDtoCodeEnum.CustomerInitialStatusNotAllowed,
];
